<div [formArrayName]="formArrayName" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start start">
    <div class="blue" fxLayout="row" fxLayoutGap="3px" fxLayoutAlign="start center">
        <mat-icon class="access-icon">{{ icon }}</mat-icon>
        <span class="title-label">{{ title }}</span>
    </div>
    <div
        class="access-list"
        fxLayout="column"
        fxLayoutAlign="start space-between"
        cdkDropList
        [cdkDropListData]="quickAccessData"
        cdkDropListLockAxis="y"
        (cdkDropListDropped)="drop($event)"
    >
        <div
            cdkDragBoundary=".access-list"
            cdkDrag
            [cdkDragData]="quickAccessFormArray.at(i).value"
            class="access-item {{ context }}"
            *ngFor="let quickAccessGroup of quickAccessFormArray.controls; let i = index"
            [formGroup]="quickAccessGroup | cast"
        >
            <mat-checkbox
                [matTooltip]="quickAccessGroup.value.route"
                class="check-access"
                (click)="$event.stopPropagation()"
                (change)="onEnabledChange(i)"
                formControlName="enabled"
                [indeterminate]="false"
                [color]="context === 'au' ? 'primary' : context === 'admin' ? 'accent' : 'warn'"
                [ngClass]="{ 'master-checkbox': context === 'master' }"
            >
                {{ quickAccessGroup.value.label }}</mat-checkbox
            >

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <button
                    class="grey"
                    matTooltip="Appears in the main menu"
                    i18n-matTooltip="@@appearInMainMenu"
                    (click)="
                        this.quickAccessFormArray.at(i).get('enabled').patchValue(!quickAccessGroup.value.navbar);
                        onClickShortlisted(i, quickAccessGroup.value.navbar)
                    "
                    mat-icon-button
                    fxFlex="0 0 auto"
                >
                    <mat-icon>{{
                        quickAccessGroup.value.navbar ? 'format_list_bulleted' : 'filter_list_off'
                    }}</mat-icon>
                </button>
                <button
                    *ngIf="!!user && !customer"
                    class="grey"
                    matTooltip="Add to favorite"
                    i18n-matTooltip="@@addToFavorite"
                    (click)="
                        this.quickAccessFormArray.at(i).get('enabled').patchValue(!quickAccessGroup.value.favorite);
                        onClickFavorite(i, quickAccessGroup.value.favorite)
                    "
                    mat-icon-button
                    fxFlex="0 0 auto"
                >
                    <mat-icon>{{ quickAccessGroup.value.favorite ? 'star' : 'star_border' }}</mat-icon>
                </button>
                <button
                    class="grey"
                    matTooltip="Delete"
                    i18n-matTooltip="@@delete"
                    (click)="onDelete(i)"
                    [disabled]="quickAccessGroup.value.default"
                    mat-icon-button
                    fxFlex="0 0 auto"
                >
                    <mat-icon>delete_outline</mat-icon>
                </button>
                <button class="drag-handle" mat-icon-button cdkDragHandle (click)="$event.stopPropagation()">
                    <mat-icon>sort</mat-icon>
                </button>
            </div>
            <div class="option-custom-placeholder access-item {{ context }}" *cdkDragPlaceholder>
                {{ quickAccessGroup.value.label }}
            </div>
        </div>
    </div>
</div>
